
import { toast as shadcnToast } from "@/hooks/use-toast";

// This component is now a proxy that redirects sonner toasts to our shadcn toast implementation
export const Toaster = () => {
  console.log("[Sonner] Redirecting to Shadcn toast");
  return null;
};

// Add this to help migrate from sonner to shadcn/ui toasts
export const toast = {
  success: (message: string, options = {}) => {
    console.log("[Sonner] Success toast:", message);
    return shadcnToast({
      title: message,
      // Use a valid variant from shadcn toast
      variant: "default",
      className: "bg-green-50 border-green-300 text-green-800",
      ...options
    });
  },
  error: (message: string, options = {}) => {
    console.log("[Sonner] Error toast:", message);
    return shadcnToast({
      title: message,
      variant: "destructive",
      ...options
    });
  },
  info: (message: string, options = {}) => {
    console.log("[Sonner] Info toast:", message);
    return shadcnToast({
      title: message,
      variant: "default",
      className: "bg-blue-50 border-blue-300 text-blue-800",
      ...options
    });
  },
  warning: (message: string, options = {}) => {
    console.log("[Sonner] Warning toast:", message);
    return shadcnToast({
      title: message,
      variant: "default",
      className: "bg-amber-50 border-amber-300 text-amber-800",
      ...options
    });
  },
  // Basic toast function
  custom: shadcnToast,
  // Default toast function
  default: shadcnToast,
};

// Make the default function call work too
export default function ProxiedToast(props: any) {
  console.log("[Sonner] Default toast call:", props);
  return shadcnToast(props);
}
